import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import classnames from 'classnames2';
import React from 'react';
import { Description } from '../Description';
import * as radioStyles from './RadioButton.scss';
import { RadioIndicatorSVG } from './RadioIndicatorSVG';

function createRadioButton(displayName, labelSizeStyle) {
  var RadioButtonKind = function RadioButtonKind(props) {
    var _classnames;

    var idName = props.name ? props.name.replace(/\s/g, '') : '';
    var idLabel = props.label ? props.label.replace(/\s/g, '') : '';
    var radioLabel = "radioLabel-".concat(idName, "-").concat(idLabel);
    return React.createElement("label", {
      className: classnames(radioStyles.label, labelSizeStyle, (_classnames = {}, _defineProperty(_classnames, radioStyles.labelSelected, props.selected), _defineProperty(_classnames, radioStyles.labelDisabled, props.disabled), _classnames)),
      "data-test": props.dataTest,
      title: props.tooltip
    }, React.createElement("input", {
      type: "radio",
      name: props.name,
      className: radioStyles.input,
      checked: props.selected,
      "aria-checked": props.selected,
      "aria-labelledby": radioLabel,
      disabled: props.disabled,
      onChange: function onChange() {
        props.onChange(props.value);
      }
    }), React.createElement(RadioIndicatorSVG, {
      containerClassName: radioStyles.indicator,
      backgroundClassName: radioStyles.indicatorBackground,
      outerRingClassName: radioStyles.indicatorOuterRing,
      innerRingClassName: radioStyles.indicatorInnerRing
    }), React.createElement("div", {
      className: radioStyles.labelAndDescriptionWrapper,
      id: radioLabel
    }, props.label, props.description && (typeof props.description === 'string' ? React.createElement(Description, null, props.description) : props.description)));
  };

  RadioButtonKind.displayName = displayName;
  return RadioButtonKind;
}

var DefaultRadioButton = createRadioButton('RadioButton.Default', radioStyles.labelDefault);
export var RadioButton = Object.assign(DefaultRadioButton, {
  Default: DefaultRadioButton,
  Small: createRadioButton('RadioButton.Small', radioStyles.labelSmall)
});